// extracted by mini-css-extract-plugin
export var dropdownButton = "_2f-0";
export var fullWidthDropdownButton = "_2f-1";
export var icon = "_2f-3";
export var iconPlaceholder = "_2f-2";
export var menuItemRow = "_2f-9";
export var separator = "_2f-e";
export var shortcutContainer = "_2f-7";
export var shortcutContainerFilled = "_2f-8";
export var shortcutIconLg = "_2f-6";
export var shortcutIconMd = "_2f-5";
export var shortcutIconSm = "_2f-4";
export var submenuChevron = "_2f-d";
export var submenuDropdown = "_2f-a";
export var submenuTriggerRow = "_2f-b";
export var submenuTriggerRowOpen = "_2f-c";